module.exports = __webpack_public_path__ + "img/medio5.fe364710.jpg";